export const stripeElementStyles = {
    base: {
        fontSize: '18px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontWeight: '300',
        '::placeholder': {
            color: '#CFD7E0'
        }
    }
};
